import {
    EditIcon as SourceEditIcon
} from 'SourceComponent/EditIcon/EditIcon.component';

/** @namespace Bodypwa/Component/EditIcon/Component */
export class EditIconComponent extends SourceEditIcon {
    render() {
        return (
            <svg
              block="EditIcon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                { /* eslint-disable-next-line max-len */ }
                <path fillRule="evenodd" clipRule="evenodd" d="M0 20H5.52939L19.4106 6.11875C20.1965 5.33293 20.1964 4.05887 19.4106 3.27306L16.7269 0.589361C15.9411 -0.196454 14.6671 -0.196454 13.8812 0.589362L0 14.4706L0 20ZM12.9667 5.06102L2.51526 15.5125L2.51526 17.4847L4.48755 17.4847L14.939 7.03329L12.9667 5.06102ZM14.7453 3.28246L16.7175 5.25473L17.2764 4.6959L15.3041 2.72363L14.7453 3.28246Z" />
            </svg>
        );
    }
}

export default EditIconComponent;
